/* eslint no-console: ["error", { allow: ["error"] }] */

import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import Text from '../Text';
import Carousel from '../Carousel';
import Image from '../Image';
import ImageTitleBody from '../ImageTitleBody';
import MixedContent from '../MixedContent';
import TitleContent from '../TitleContent';
import Link from '../Link';
import Document from '../Document';
import InternalLink from '../InternalLink';
import Title from '../Title';
import TitleBody from '../TitleBody';
import TwoColumns from '../TwoColumns';
import ImageHeadedTwoColumns from '../ImageHeadedTwoColumns';
import DataList from '../DataList';
import Table from '../Table';

const debug = window
  && window.location
  && Object.prototype.hasOwnProperty.call(queryString.parse(window.location.search), 'debug');

const NoComponent = ({ type }) => (
  debug
    ? (
      <em
        style={{
          display: 'block',
          backgroundColor: 'rgba(128, 16, 16, .1)',
          padding: 2,
          margin: 2,
        }}
      >
        Pas de rendu configuré pour : <code>{type}</code>
      </em>
    )
    : null
);

const TYPES = {
  paragraph: Text,
  text: Text,

  carousel: Carousel,
  document: Document,
  image: Image,
  image_title_body: ImageTitleBody,
  mixed_content: MixedContent,
  title_content: TitleContent,
  link: Link,
  internal_link: InternalLink,
  title: Title,
  title_body: TitleBody,
  two_columns: TwoColumns,
  image_headed_two_columns: ImageHeadedTwoColumns,

  data_list: DataList,
  table: Table,
};

function getComponent (type) {
  if (Object.prototype.hasOwnProperty.call(TYPES, type)) {
    return TYPES[type];
  }

  // Debug purpose. See how to manage this : maybe throwing error, or just return null
  console.error(`type ${type} is invalid`);
  return () => <NoComponent type={type} />;
}

export class Node extends React.Component {
  static propTypes = {
    blocs: PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
    })),
    children: PropTypes.func,
  };

  static defaultProps = {
    blocs: [],
    children: ({ Component, ...props }) => <Component {...props} />,
  };

  render () {
    const { blocs, children: renderNode, ...props } = this.props;

    return blocs.map(({ type, value, id }) => (
      <React.Fragment key={id}>
        {renderNode({ ...props, type, value, Component: getComponent(type) })}
      </React.Fragment>
    ));
  }
}

export default Node;



// WEBPACK FOOTER //
// ./src/modules/CMS/components/Node/index.js